import { AbstractModal } from '../AbstractModal';
import type { HexMapState } from '../../engine/render/renderer';
import type { ContentBuilder } from '../ui/ContentBuilder';
import { t } from '../../i18n/translations';
import type { Tile } from '../../engine/hex/types';

const REPORT_TILE: Tile = {
    id: 'battle_report',
    position: { q: 0, r: 0, s: 0 },
    biome: { type: 'plains' },
    resources: {},
};

export class BattleReportModal extends AbstractModal {
    private reportId: string;

    constructor(rect: { x: number; y: number; w: number; h: number }, reportId: string) {
        super(REPORT_TILE, rect, null);
        this.reportId = reportId;
        this.id = `battle_report_${reportId}`;
        this.showTileHighlight = false;
        this.allowCloseDuringTutorial = true;
    }

    getHeaderLabel(state: HexMapState): string {
        return t(state.config.ui.language, 'battle.report.title');
    }

    buildContent(state: HexMapState, builder: ContentBuilder): void {
        const lang = state.config.ui.language;
        const report = state.battleReports.find((entry) => entry.id === this.reportId);
        if (!report) {
            builder.text(t(lang, 'battle.report.missing'));
            return;
        }

        builder.section(t(lang, 'battle.report.summary'), (section) => {
            section.text(t(lang, 'battle.report.tile', report.tileId));
            section.text(
                t(lang, 'battle.report.result', t(lang, `battle.result.${report.outcome.winner}`)),
            );
            section.text(
                t(
                    lang,
                    'battle.report.losses',
                    report.outcome.attackerLosses,
                    report.outcome.defenderLosses,
                ),
            );
        });

        builder.section(t(lang, 'battle.report.rounds'), (section) => {
            if (report.rounds.length === 0) {
                section.text(t(lang, 'battle.report.roundsNone'));
                return;
            }
            report.rounds.forEach((round) => {
                section.text(t(lang, 'battle.report.roundLabel', round.round));
                section.text(
                    t(
                        lang,
                        'battle.report.roundDetail',
                        round.attackerKills,
                        round.defenderKills,
                        round.attackerRemaining,
                        round.defenderRemaining,
                    ),
                    'muted',
                );
                section.spacer(4);
            });
        });
    }
}
